module.exports = __webpack_public_path__ + "static/media/20191214_195311.54786eef.jpg";